module.exports = __webpack_public_path__ + "static/img/jsyl.2c85f216.png";